import PropTypes from 'prop-types';
import React from 'react';

import IconBounds from '../IconBounds';
import { AdminSecurity } from '../shapes';


const AdminSecuritySvg = (props) => (
  <g>
    <IconBounds />
    <AdminSecurity {...props} />
  </g>
);

AdminSecuritySvg.propTypes = {
  fill: PropTypes.string,
  stroke: PropTypes.string,
  strokeWidth: PropTypes.number,
};

AdminSecuritySvg.defaultProps = {
  fill: '#000',
  stroke: '#000',
  strokeWidth: 1,
};


export default AdminSecuritySvg;
